import { IAppMessageMetadata } from "common/api/appMessage.service";
import { AppMessageRecipientRecord, appMessageRecipientFromJSON } from "common/records/AppMessage";
import {
  ADD_APP_MESSAGE,
  AppMessageActions,
  CLEAR_APP_MESSAGES,
  RECEIVE_APP_MESSAGE,
  RECEIVE_APP_MESSAGES,
  SET_LOAD_FAILED,
  UPDATE_APP_MESSAGE,
} from "common/reducers/appMessage.actions";
import { RootActions, RootState } from "common/reducers";
import { Map, Record } from "immutable";

export const AppMessageMetadataRecord = Record<IAppMessageMetadata>({
  total: 0,
  unread_total: 0,
  page_number: 1,
  per_page: 20,
  total_pages: 1,
});

export const AppMessageUiStateRecord = Record({
  loadFailed: false,
});

export const AppMessageStateRecord = Record({
  byId: Map<string, AppMessageRecipientRecord>(),
  uiState: AppMessageUiStateRecord(),
  metadata: AppMessageMetadataRecord(),
});

export const initialState = AppMessageStateRecord();

export type AppMessageState = typeof initialState;

export const model = "appMessages";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case RECEIVE_APP_MESSAGE: {
      const { message } = action.payload;

      return state.setIn([model, "byId", message.id], appMessageRecipientFromJSON(message));
    }

    case RECEIVE_APP_MESSAGES: {
      const { messages, metadata } = action.payload;

      messages.forEach((message) => {
        state = reducer(state, AppMessageActions.receiveAppMessage(message));
      });

      return state.setIn([model, "metadata"], AppMessageMetadataRecord(metadata));
    }

    case ADD_APP_MESSAGE:
    case UPDATE_APP_MESSAGE: {
      const { message, metadata } = action.payload;

      return state
        .setIn([model, "byId", message.id], appMessageRecipientFromJSON(message))
        .setIn([model, "metadata"], AppMessageMetadataRecord(metadata));
    }

    case SET_LOAD_FAILED:
      return state.setIn([model, "uiState", "loadFailed"], action.payload.failed);

    case CLEAR_APP_MESSAGES:
      return state.set(model, initialState);

    default:
      return state;
  }
};
